import type { User as UserEntry } from './model/types';
import PeopleField from './view';

export type User = UserEntry;
export default PeopleField;
